import { render, staticRenderFns } from "./BtnAdicionarExperiencia.vue?vue&type=template&id=769e80f5&"
import script from "./BtnAdicionarExperiencia.vue?vue&type=script&lang=js&"
export * from "./BtnAdicionarExperiencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports